import React from 'react';

import { TIntl } from 'types/i18n';

export const IntlContext = React.createContext<null | TIntl>(null);
